import { Box, Typography } from "@mui/material"
import Style from '../../SipocDiagram.module.css';


interface KPIBasketProps {

  kpiBasketList: any

}
const KPIBasket: React.FC<KPIBasketProps> = ({ kpiBasketList }) => {
  return (
    <>
     <Typography variant="h6">KPI Basket</Typography>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                maxHeight: '300px', // Adjust this as needed
                overflow: 'auto', // Enables scrolling if content overflows
                padding: 2, // Optional, adds spacing around the scrollable area
              }}
            >
              {kpiBasketList.map((item: any, index: number) => (
                <Box key={index} sx={{ display: 'flex', justifyContent: 'space-between', mb: 4, borderBottom: '1px solid #000', pb: 2 }}>
                  {/* First Column */}
                  <Box className="data_firstcol" sx={{ flex: 1, pr: 2 }}>
                    <Box sx={{ pt: 2 }}>
                      <Typography variant="h5" className={Style.spoicdatatitle}>Indicator Name</Typography>
                      <Typography className={Style.spoicdatatext}>{item.indicator_name}</Typography>
                    </Box>
                    <Box sx={{ pt: 2 }}>
                      <Typography variant="h5" className={Style.spoicdatatitle}>Unit of Measure</Typography>
                      <Typography className={Style.spoicdatatext}>{item.unit_of_measure}</Typography>
                    </Box>
                    <Box sx={{ pt: 2 }}>
                      <Typography variant="h5" className={Style.spoicdatatitle}>Check Items</Typography>
                      <Typography className={Style.spoicdatatext}>{item.check_items}</Typography>
                    </Box>
                    <Box sx={{ pt: 2 }}>
                      <Typography variant="h5" className={Style.spoicdatatitle}>Is it related to any global goal?</Typography>
                      <Typography className={Style.spoicdatatext}>{item.is_it_related_to_any_global_goal ? 'Yes' : 'No'}</Typography>
                    </Box>
                    <Box sx={{ pt: 2 }}>
                      <Typography variant="h5" className={Style.spoicdatatitle}>Year</Typography>
                      <Typography className={Style.spoicdatatext}>{item.year}</Typography>
                    </Box>
                    <Box sx={{ pt: 2 }}>
                      <Typography variant="h5" className={Style.spoicdatatitle}>Previous FY Value</Typography>
                      <Typography className={Style.spoicdatatext}>{item.previous_fy_value}</Typography>
                    </Box>

                  </Box>

                  {/* Second Column */}
                  <Box className="data_secondcol" sx={{ flex: 1, pl: 2 }}>
                    <Box sx={{ pt: 2 }}>
                      <Typography variant="h5" className={Style.spoicdatatitle}>What does it measure?</Typography>
                      <Typography className={Style.spoicdatatext}>{item.what_does_it_measure}</Typography>
                    </Box>
                    <Box sx={{ pt: 2 }}>
                      <Typography variant="h5" className={Style.spoicdatatitle}>What is the calculation formula?</Typography>
                      <Typography className={Style.spoicdatatext}>{item.what_is_the_calculation_formula}</Typography>
                    </Box>
                    <Box sx={{ pt: 2 }}>
                      <Typography variant="h5" className={Style.spoicdatatitle}>Who is responsible?</Typography>
                      <Typography className={Style.spoicdatatext}>{item.who_is_responsible}</Typography>
                    </Box>
                    <Box sx={{ pt: 2 }}>
                      <Typography variant="h5" className={Style.spoicdatatitle}>Which Goal?</Typography>
                      <Typography className={Style.spoicdatatext}>{item.whichgoal}</Typography>
                    </Box>
                    <Box sx={{ pt: 2 }}>
                      <Typography variant="h5" className={Style.spoicdatatitle}>Current YDT Value</Typography>
                      <Typography className={Style.spoicdatatext}>{item.current_ytd_value}</Typography>
                    </Box>
                    <Box sx={{ pt: 2 }}>
                      <Typography variant="h5" className={Style.spoicdatatitle}>Target Value</Typography>
                      <Typography className={Style.spoicdatatext}>{item.target_value}</Typography>
                    </Box>
                  </Box>
                </Box>
              ))}
            </Box>
            </>
  )
}

export default KPIBasket